import React, { useEffect } from 'react';
import ChatSessionComp from './ChatSessionComp';
import { useQueryCall } from '../../../api/react-client';
import { EmptyState } from '../../commons';
import { InvalidSearchImg } from '../../../images/images';
import Shimmer from 'sushiweb/Shimmer';
import { MetricsForJumboEvent } from '../../../analytics/constants';
import './ChatSummary.scss';
import {
  IVAChatSummaryBtnClick,
  SmartplugChatSummaryBtnClick,
} from '../../../analytics/context-passing/events';

const chatSummaryEndpoint = 'user/get_chat_summary';

const modes = {
  IVA: 'iva',
  SMARTPLUG: 'smartplug',
};

const ChatSummary = (props) => {
  const { orderId, userId, mode, complaintType, cartId } = props;

  // query call to get all chat sessions
  const { data, isLoading } = useQueryCall(
    {},
    `${chatSummaryEndpoint}?order_id=${orderId}&user_id=${userId}`,
    ['chat_summary', orderId, userId],
  );

  useEffect(() => {
    if (!data || isLoading) return;

    const properties = {
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.feature_meta]: {
        ...(mode === modes.IVA && {
          complaint_type: complaintType,
        }),
        sessions_count: Array.isArray(data?.sessions)
          ? data.sessions.length
          : 0,
        session_data: JSON.stringify(
          Array.isArray(data?.sessions)
            ? data.sessions
                .map((session) => {
                  if (!session) return null;
                  return {
                    session_id: session.session_id,
                    ...(session.complain_type && {
                      complaint_type: session.complain_type,
                    }),
                    ...(session.node && {
                      complaint_node: session.node,
                    }),
                  };
                })
                .filter(Boolean)
            : [],
        ),
      },
    };

    // Send analytics event based on the mode
    if (mode === modes.IVA) {
      IVAChatSummaryBtnClick(properties);
    } else if (mode === modes.SMARTPLUG) {
      SmartplugChatSummaryBtnClick(properties);
    }
  }, [data, isLoading, mode, userId, orderId, cartId, complaintType]);

  if (isLoading)
    return (
      <div className='tw-w-full tw-flex tw-flex-col tw-gap-5 tw-rounded-lg'>
        <div className='tw-rounded-lg tw-overflow-hidden'>
          <Shimmer height='10rem' width='100%' />
        </div>
        <div className='tw-rounded-lg tw-overflow-hidden'>
          <Shimmer height='40rem' width='100%' />
        </div>
      </div>
    );

  if (!data?.sessions || data.sessions.length === 0) {
    return (
      <div className='tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center'>
        <EmptyState
          img={InvalidSearchImg}
          heading={data?.message || 'No chat sessions available!'}
          isPop={true}
        />
      </div>
    );
  }

  return (
    <div className='tw-w-full tw-px-1 tw-pb-10 tw-flex tw-flex-col tw-gap-8'>
      {data.sessions.map((session, index) => (
        <div
          key={session?.session_id || index}
          className='chat-session-animate'
          style={{ animationDelay: `${index * 60}ms` }}
        >
          <ChatSessionComp session={session || {}} {...(props || {})} />
        </div>
      ))}
    </div>
  );
};

export default ChatSummary;
